import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QuoteSessionQuery } from '@app/store/session/session.query';
import { PaymentSchedule } from '@models/PaymentSchedule';
import { getFrequencyViewValue } from '@utils/frequency.util';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Component({
	selector: 'qe-payment-schedule-modal',
	templateUrl: './payment-schedule-modal.component.html',
	styleUrls: ['./payment-schedule-modal.component.scss'],
})
export class PaymentScheduleModalComponent implements OnDestroy {
	public displayedColumns: string[] = ['date', 'premium', 'routineCare', 'total'];
	public paymentFrequency$: Observable<string>;
	private readonly ngUnsubscribe$: Subject<boolean> = new Subject();

	constructor(
		public dialogRef: MatDialogRef<PaymentScheduleModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: { paymentSchedule: Observable<PaymentSchedule[]>},
		private readonly session: QuoteSessionQuery,
	) {
		this.paymentFrequency$ = this.session.paymentFrequency$()
			.pipe(
				takeUntil(this.ngUnsubscribe$),
				map(f => getFrequencyViewValue(f)),
			);
	}

	ngOnDestroy(): void {
		this.ngUnsubscribe$.next(true);
		this.ngUnsubscribe$.unsubscribe();
	}
}
